import React from 'react';
import { Typography, Card, CardContent } from '@mui/material';

const PrioritySetup = () => {
  return (
    <Card variant="outlined" sx={{ borderColor: 'divider', bgcolor: 'background.paper' }}>
      <CardContent>
        <Typography variant="h6" color="text.primary">Priority Setup</Typography>
        {/* Add your Priority Setup content here */}
      </CardContent>
    </Card>
  );
};

export default PrioritySetup;
